import { lazy, ReactNode, useCallback } from 'react'
import { StringParam, useQueryParam } from 'use-query-params'
import { PDF_URL_QUERY_STR } from '@/components/ActivityViewers/articleViewer/ArticleViewerContentRenderer'
import { CustomSuspense } from '@/components/CustomSuspense/CustomSuspense'

const PDFViewer = lazy(() => import('@lms/lms-pdf-viewer').then((module) => ({ default: module.PDFViewer })))

export const PDF_TITLE_QUERY_STR = 'pdfTitle'

type Props = {
  children: ReactNode
}

export const MFWrapper = (props: Props) => {
  const { children } = props

  // these are set at the learn/RichTextRenderer.vue
  const [pdfURL, setPdfURL] = useQueryParam(PDF_URL_QUERY_STR, StringParam)
  const [pdfTitle, setPdfTitle] = useQueryParam(PDF_TITLE_QUERY_STR, StringParam)

  const handleClosePDF = useCallback(() => {
    setPdfURL(null)
    setPdfTitle(null)
  }, [setPdfURL, setPdfTitle])

  return (
    <>
      {children}

      {pdfURL && (
        <CustomSuspense>
          <PDFViewer title={pdfTitle!} src={pdfURL} onClosePdf={handleClosePDF} />
        </CustomSuspense>
      )}
    </>
  )
}
